import React, { useState } from "react";
import ComparisonModal from "./popup";
const IndexSections = () => {
  const [modalStatus, setModalStatus] = useState(false);
  
  return (
    <>
      <div className="snX" data-aos="fade-up" data-aos-delay="500" data-aos-duration="1000">
         <div className="d-flex justify-content-between gap-1 align-items-start">
             <div>
                 <h2 className='gradient-stroke-text '>Market cap, price, volume comparison</h2>
                 <p>Monitor UFO's price, trading volume, and market cap ratio to evaluate its stability, growth, and performance metrics.
                 </p>
                 <button onClick={() => setModalStatus(true)} className="mybtn underline text-white p-0"><span>View Now</span></button>
             </div>
             <div>
             </div>
         </div>
      </div>
      <ComparisonModal modalIsOpen={modalStatus} closeModal={() => setModalStatus(false)}/>
    </>
  );
};

export default IndexSections;
